import { render, staticRenderFns } from "./selectStatue.vue?vue&type=template&id=7bbd736a&"
import script from "./selectStatue.vue?vue&type=script&lang=js&"
export * from "./selectStatue.vue?vue&type=script&lang=js&"
import style0 from "./selectStatue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports